import api from './api';
import { API_ROUTES } from '../config/apiRoutes';

export const resumeService = {
  getUserResumes: async () => {
    try {
      return await api.get(API_ROUTES.resumes.list);
    } catch (error) {
      console.error('Error fetching resumes:', error);
      throw error;
    }
  },

  deleteResume: async (id) => {
    try {
      return await api.delete(API_ROUTES.resumes.delete(id));
    } catch (error) {
      console.error('Error deleting resume:', error);
      throw error;
    }
  },

  createResume: async (metadata) => {
    try {
      return await api.post(API_ROUTES.resumes.create, metadata);
    } catch (error) {
      console.error('Error creating resume:', error);
      throw error;
    }
  },

  // New methods for individual sections
  createExperience: async (resumeId, experienceData) => {
    try {
      return await api.post(API_ROUTES.experience.create(resumeId), experienceData);
    } catch (error) {
      console.error('Error creating experience:', error);
      throw error;
    }
  },

  deleteExperience: async (resumeId, experienceId) => {
    try {
      return await api.delete(API_ROUTES.experience.delete(resumeId, experienceId));
    } catch (error) {
      console.error('Error deleting experience:', error);
      throw error;
    }
  },

  createEducation: async (resumeId, educationData) => {
    try {
      return await api.post(API_ROUTES.education.create(resumeId), educationData);
    } catch (error) {
      console.error('Error creating education:', error);
      throw error;
    }
  },

  deleteEducation: async (resumeId, educationId) => {
    try {
      return await api.delete(API_ROUTES.education.delete(resumeId, educationId));
    } catch (error) {
      console.error('Error deleting education:', error);
      throw error;
    }
  },

  createSkill: async (resumeId, skillData) => {
    try {
      return await api.post(API_ROUTES.skills.create(resumeId), skillData);
    } catch (error) {
      console.error('Error creating skill:', error);
      throw error;
    }
  },

  deleteSkill: async (resumeId, skillId) => {
    try {
      return await api.delete(API_ROUTES.skills.delete(resumeId, skillId));
    } catch (error) {
      console.error('Error deleting skill:', error);
      throw error;
    }
  },

  getSuggestions: async (id) => {
    try {
      return await api.get(API_ROUTES.resumes.getSuggestions(id));
    } catch (error) {
      console.error('Error fetching suggestions:', error);
      throw error;  
    }
  },

  getResume: async (id) => {
    try {
      return await api.get(API_ROUTES.resumes.get(id));
    } catch (error) {
      console.error('Error in getResume:', error);
      return null;
    }
  },

};
